var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('attachment',[_c('download-icon',{staticClass:"download-icon",attrs:{"slot":"right"},slot:"right"}),_c('a',{attrs:{"href":_vm.targetUrl,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.filename))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }